import React, { useMemo, useState } from "react"
import { Container, Heading, Box } from "@chakra-ui/react"
import { useRecentlyViewedContext } from "@app/providers/recentlyViewed"
import ProductCard from "@app/components/Product/ProductCard"
import { useMedia } from "@app/hooks/useMedia"
import ProductCardDrawer from "@app/components/ProductCardDrawer"
import TileCarousel from "@app/components/TileCarousel/TileCarousel"

type Props = {
  _key: any
  title: string
  product: any
  imageViewType: string
  sectionLayout: any
  layoutCarouselItemsPerPage: number
  handleTrackingClick: () => void
}

const RecentlyViewedProducts: React.FC<Props> = ({ product, layoutCarouselItemsPerPage, handleTrackingClick }) => {
  const { isBase } = useMedia()
  const { recentlyViewed } = useRecentlyViewedContext()
  const [quickViewProduct, setQuickViewProduct] = useState<BundleProduct | null>(null)

  const carouselItemsPerPage = useMemo(() => layoutCarouselItemsPerPage || 3, [layoutCarouselItemsPerPage])

  let filteredRecentlyViewed: any = useMemo(() => {
    return recentlyViewed
      ?.filter((item: any) => item?.handle && item?.handle !== product?.handle)
      ?.slice(0, isBase ? carouselItemsPerPage : carouselItemsPerPage * 2)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [carouselItemsPerPage, isBase, product?.handle, recentlyViewed])

  const hasProductBadge = useMemo(
    () => filteredRecentlyViewed?.some(item => item?.product?.tags?.find(tag => tag?.includes("label"))),
    [filteredRecentlyViewed]
  )

  filteredRecentlyViewed = filteredRecentlyViewed?.filter(item => !item?.tags?.find(tag => tag == "stl"))

  return filteredRecentlyViewed?.length ? (
    <>
      <Container as="section" py={{ base: "48px", md: "64px" }}>
        <Heading as="h2" size="h2" mb={2.5} textAlign="center">
          Recently Viewed
        </Heading>
        <TileCarousel
          slidesPerView={6}
          slidesPerViewMobile={1.15}
          navigationProps={{ transform: `50%`, top: "calc(490px / 2)", bg: "brand.primary", color: "black" }}
        >
          {filteredRecentlyViewed?.slice(0, 6).map((item: any, idx: number) => (
            <Box key={idx} mb={3.5}>
              <ProductCard
                location={location}
                item={item}
                fullSize={true}
                handleTrackingClick={handleTrackingClick}
                onQuickView={setQuickViewProduct}
                showBadgePlaceholder={hasProductBadge}
              />
            </Box>
          ))}
        </TileCarousel>
      </Container>
      {quickViewProduct && (
        <ProductCardDrawer
          product={quickViewProduct}
          updateQuickViewProduct={product => setQuickViewProduct(product)}
          onClose={() => setQuickViewProduct(null)}
        />
      )}
    </>
  ) : null
}

export default React.memo(RecentlyViewedProducts)
